import { differenceInDays, format, isToday } from 'date-fns';

export const useEventDays = ({
	event_date,
	isCompleted,
}: {
	event_date: Date;
	isCompleted: boolean;
}) => {
	return getEventDays({ event_date: event_date, isCompleted: isCompleted });
};

export const getEventDays = ({
	event_date,
	isCompleted,
}: {
	event_date: Date;
	isCompleted: boolean;
}) => {
	const today = new Date(format(new Date(), 'yyyy-MM-dd'));
	const eventDate = new Date(event_date);

	const restDays = differenceInDays(eventDate, today);
	const isUrgent = !isCompleted && restDays <= 14;

	let restDaysString = '';

	// console.log(today);
	// console.log(restDays);

	if (restDays === 0) {
		if (isToday(eventDate)) {
			restDaysString = 'DNES';
		}
	} else if (restDays > 0) {
		if (restDays === 1) {
			restDaysString += 'ZÍTRA';
		} else {
			restDaysString = 'Za ' + restDays;

			if (restDays == 1) {
				restDaysString += ' den';
			} else if (restDays <= 4) {
				restDaysString += ' dny';
			} else {
				restDaysString += ' dní';
			}
		}
	} else if (restDays < 0) {
		restDaysString = 'Pred ' + restDays * -1;

		if (restDays === -1) {
			restDaysString += ' dnem';
		} else {
			restDaysString += ' dny';
		}
	}

	return { restDays, isUrgent, restDaysString };
};
